import { makeStyles } from "@material-ui/core";

export const useResultStyles = makeStyles(theme => ({
  result: {
    marginTop: 20,
    border: "1px solid",
    color: theme.palette.text.primary,
  },
}));
